module.exports = __webpack_public_path__ + "img/SignEditorRichText.cd78b299.png";